<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="this.titleinvoice +' '+ $t('invoices')"
          :directory="$t('datatables')"
          :icon="'grid'"/>
      </div>
      <!-- <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
        <div class="p-primary align-items-center primary-card-color border-bottom">
        <ul class="nav tab-filter-menu d-inline-flex justify-content-flex-end">
            <li
            class="nav-item"
            v-for="(item, index) in userFilterOptions"
            :key="index"
            >
            <a
                href="#"
                class="nav-link font-size-default py-0"
                :class="[
                filteredData.status == item.id
                    ? 'active'
                    : index === 0 && filteredData.status === ''
                    ? 'active'
                    : '',
                ]"
                @click.prevent="getFilterValue(item.id)"
            >
                {{ item.value }}
            </a>
            </li>
        </ul>
        <div class="float-right">
            <app-search @input="getSearchValue" />
        </div>
        </div>
      </div> -->
    </div>
    <h5 class="text-danger text-center" v-if="pendingMessage == true">{{ $t('pending_invoice_message') }}</h5>
    <app-table
      :id="tableId"
      :options="options"
      @action="getListAction"
    />
  </div>
</template>

<script>
// import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../../Config/ApiUrl";
import { TableHelpers } from "../../../Demo/Tables/mixins/TableHelpers";
import { axiosGet } from '../../../../../Helpers/AxiosHelper';

export default {
  // extends: CoreLibrary,
  name: "tab-filter",
  mixins: [TableHelpers],
  data() {
    return {
      pendingMessage: false,
      invoice: {},
      isAddEditModalActive: false,
      isEditModalActive:false,
      deleteConfirmationModalActive: false,
      deleteLoader: false,
      selectedUrl: "",
      titleinvoice: "",
      tableId: "filter-without-wrapper",
      filteredData: {
        status: "",
      },
      search: "",
      rowData: {},
      options: {
        name: this.$t("tab_filter"),
        url: actions.PERSONAL_INVOICE_LIST,
        datatableWrapper: false,
        tableShadow: false,
        showHeader: true,
        columns: [
          {
            title: this.$t("invoice_#"),
            type: "custom-html",
            key: "invoice_number",
            modifier: (value,row) => {
                return `<a href="#" id="${row.id}"  data-attribute="${row.id}" @click=${this.myFunction(row.id)}>${this.$t(value)}</a>`; 
            },
          },
          // {
          //   title: this.$t("customers"),
          //   type: "custom-html",
          //   key: "company_name",
          //   modifier: (value) => {
          //     let company_name = value ;
          //     this.titleinvoice = company_name;
          //     return `<span>${this.$t(value.company_name)}</span>`;
          //   },
          // },
          {
            title: this.$t("invoice_date"),
            type: "custom-html",
            key: "invoice_date",
            modifier: (value) => {
              return `<span>${this.$t(value)}</span>`;
            },
          },
          {
            title: this.$t("due_date"),
            type: "custom-html",
            key: "due_date",
            modifier: (value) => {
              var result = '';
              let ClassName = "warning";

              if (value == null) {
                result = "None";
                ClassName = 'danger';
              }
              else {
                const moment = require('moment');
                // Define your due date and current date
                const dueDate = moment(value+' 23:59:59'); // Replace with your due date
                const currentDate = moment(); // Current date and time

                // Calculate the difference in time
                const timeDiff = dueDate.diff(currentDate);
                if (timeDiff > 0) {
                  const duration = moment.duration(timeDiff);
                  if (duration.days() > 0) {
                    result = `${duration.days()} day${duration.days() > 1 ? 's' : ''} left`;
                    if(duration.days() > 30) {
                      ClassName = 'success';
                    }
                  } else if (duration.hours() > 0) {
                    result = `${duration.hours()} hour${duration.hours() > 1 ? 's' : ''} left`;
                  } else {
                    result = `${duration.minutes()} minute${duration.minutes() > 1 ? 's' : ''} left`;
                  }
                } else {
                    result = 'The due date has passed.';
                    ClassName = 'danger';
                }
              }
              // return `<span>${this.$t(result)}</span>`;
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                  result
              )}</span>`;
            },
          },
          {
            title: this.$t("total"),
            type: "custom-html",
            key: "amount",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("paid_due"),
            type: "custom-html",
            key: "amount_due",
            modifier: (value) => {
              return `<span>${this.$t(value.toString())}</span>`;
            },
          },
          {
            title: this.$t("status"),
            type: "custom-html",
            key: "status",
            isVisible: true,
             modifier: (value) => {
              let ClassName = "danger";
              let val = ''

              if (value === "succeeded") 
              {
                ClassName = `success`;
                val = 'Paid';
              } 
              else if (value === "pending") 
              {
                ClassName = `warning`;
                val = 'Overdue';
              }
              
              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                val
              )}</span>`;
            },
          },
        ],
        actions: [
          {
            title: this.$t("view"),
            icon: "eye",
            type: "none",
            component: "app-add-modal",
            modalId: "demo-add-edit-Modal",
          },
          {
            title: this.$t("payment"),
            icon: "credit-card",
            type: "none",
          },
          // {
          //     title: this.$t('download'),
          //     icon: 'download',
          //     type: 'none',
          // }
        ],
        showFilter: false,
        // showSearch: true,
        showCount: true,
        // showClearFilter: true,
        paginationType: "pagination",
        responsive: true,
        rowLimit: 10,
        showAction: true,
        orderBy: "desc",
        actionType: "dropdown",
      },
      userFilterOptions: [
        { id: "", value: "All Invoices" },
        { id: "succeeded", value: "Paid" },
        { id: "pending", value: "Un Paid" },
        // { id: "invited", value: "Invited" },
      ],
    };
  },
  created() {
    this.options.columns = [...this.options.columns, this.actionObj];
    // this.searchAndSelectFilterOptions();
  },
  methods: {
    getSearchValue(value) {
      let instance = this;
      this.search = value;
      setTimeout(function () {
        instance.$hub.$emit("reload-" + instance.tableId);
      });
    },
    getFilterValue(item) {
      this.filteredData.status = item;
      
      this.$hub.$emit("reload-" + this.tableId);
    },
    getListAction(rowData, actionObj, active) {
            this.rowData = rowData;
 
            if (actionObj.title == this.$t('view')) {
               this.view(rowData.id);
            }
            else if (actionObj.title == this.$t('payment'))
            {
              if (rowData.status == 'succeeded')
              {
                this.$toastr.s('You are already paid customer');
              }
              else
              {
                  window.location = '/admin/stripePay2/' + rowData.id;
              }
              
            }

        },
        view(id) {
           this.$emit("id", id);
        },
        myFunction(id){
          let doc = document.getElementById(id);
          if(doc){
              doc.addEventListener('click', () => {
              this.view(doc.dataset.attribute);
              }); 
          }
        },
        lastINvoice() {
          axiosGet(actions.LAST_INVOICE)
          .then((response) => {
              if (response.data.result == 'pending') {
                  this.pendingMessage = true;
              }
            })
            .catch((error) => {
              
            });
        },
    // getCompanyName() {
    //   let myLocation = location.href;
    //   let split = myLocation.split('/');
    //   
    //   let id = split[6].split('?')[0];
    //   
    //   axiosGet(actions.COMPANY_NAME+'/'+id)
    //   .then((response) => {
    //       
    //       this.titleinvoice = response.data.company_name;
    //     })
    //     .catch((error) => {
    //       
    //     });
    // },

    // getInvoice() {
    //     let myLocation = location.href;
    //     let split = myLocation.split("/");
    //     let split_ = split[6].split("?");
    //     
    //     // let a = this.options.url.append(this.id);
    //     
    //     this.options.url = this.options.url + '/' + split_[0];
    // }
    
  },
  mounted() {

    this.lastINvoice();
    // this.getInvoice();
    // this.getCompanyName();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
  },
};
</script>
